import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Context } from '../context/AppContext';

const AddRewardItemModal = ({ item, modal, setModal }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [disabledAddToCart, setDisabledAddToCart] = useState(false);
  const [alertMessages, setAlertMessages] = useState({});
  const [special_instructions, setSpecialInstructions] = useState('');
  const { language, setChangedCart, changedCart, restaurantId } = useContext(Context);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!modal) {
      // Reset state when modal is closed
      setSelectedOptions([]);
      setDisabledAddToCart(false);
      setAlertMessages({});
      setSpecialInstructions('');

    }
  }, [modal]);

 useEffect(() => {
    const validateOptions = () => {
      let allOptionsValid = true;
      let alerts = {};
  
      item?.Restaurant_Item_Attributes.forEach((attribute) => {
        const requiredOptions = attribute?.Item_Attribute?.requ || 0;
        const maxOptions = attribute?.Item_Attribute?.max_ || 0;
        const selectedOptionsCount = selectedOptions.filter(opt => opt.attributeId === attribute.id).length;
  
        // Check for required options
        if (requiredOptions > selectedOptionsCount && requiredOptions !== 0) {
          allOptionsValid = false;
          alerts[attribute.id] = `*Must Select ${requiredOptions} options and you selected ${selectedOptionsCount}`;
        }
  
        // Check for maximum options
        if (maxOptions < selectedOptionsCount && maxOptions !== 0) {
          allOptionsValid = false;
          alerts[attribute.id] = `*Maximum of ${maxOptions} options can be selected and you selected ${selectedOptionsCount}`;
        }
  
        // Clear the alert if no issue
        if (!alerts[attribute.id]) {
          alerts[attribute.id] = '';
        }
      });
  
      setAlertMessages(alerts);
      setDisabledAddToCart(!allOptionsValid);
    };
  
    validateOptions();
  }, [selectedOptions, item]);



  const handleOptionChange = (optionId, priceModifier, attributeId) => {
    const existingOption = selectedOptions.find((opt) => opt.id === optionId);

    if (existingOption) {
      // If the option is already selected, remove it
      setSelectedOptions((prevOptions) =>
        prevOptions.filter((opt) => opt.id !== optionId)
      );
    } else {
      // If the option is not selected, add it
      setSelectedOptions((prevOptions) => [
        ...prevOptions,
        { id: optionId, priceModifier, attributeId },
      ]);
    }
  };


  const handleAddItem = () => {
    try {
      setIsLoading(true);

      // Retrieve the cart from localStorage, or initialize it if it doesn't exist
      let cart = JSON.parse(localStorage.getItem(`rewardItem`)) || {}

      // Create the item to add
      const itemToAdd = {
        Item: item,
        special_instructions: special_instructions,
        options: selectedOptions,
        price: 0.00,
      };

      cart = itemToAdd;

      // Assign the itemToAdd to the freeItem property in the cart object


      // Save the updated cart back to localStorage
      localStorage.setItem(`rewardItem`, JSON.stringify(cart));

      // Reset states
      setIsLoading(false);
      setSpecialInstructions('');
      setSelectedOptions([]);
      setModal(false);
      setChangedCart(!changedCart);

    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };




 return (
  <Modal show={modal} onHide={() => setModal(false)} centered size="lg">
<div
  className="d-flex flex-column"
  style={{ height: 'auto', maxHeight: 'min(80vh, 700px)' }}
>          <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 text-center fs-4 fw-bold" >
          {language === 'en' ? item?.name : item?.chinese_name}{' '}
          <span className="text-success">(Free Item)</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 overflow-auto flex-grow-1">
        <div className="mb-4 text-center">
          {item?.image_url && (
            <img
              src={item?.image_url}
              alt={language === 'en' ? item?.name : item?.chinese_name}
              className="rounded shadow-sm"
              style={{ width: '100%', maxHeight: '240px', objectFit: 'cover' }}
            />
          )}
        </div>

        {/* {item?.description && item.description !== 'null' && (
          <p className="text-muted text-center mb-4">{item.description}</p>
        )} */}

        {item?.Restaurant_Item_Attributes?.length > 0 && (
          <div className="mb-4">
            <h6 className="fw-bold mb-3" >Options</h6>
            <Form>
    {item.Restaurant_Item_Attributes.map((attribute) => {
  // Filter options that don't have price_modifier > 0
  const filteredOptions = attribute.Item_Attribute.Item_Attribute_Options.filter(
    option => !(option.price_modifier && option.price_modifier > 0)
  );

  // If no options left, skip rendering this attribute
  if (filteredOptions.length === 0) {
    return null;
  }

  return (
    <Form.Group key={attribute.id} className="mb-4">
      <Form.Label className="fw-semibold d-flex flex-wrap gap-1">
        <span>{attribute?.Item_Attribute?.name}</span>
        {alertMessages[attribute.id] && (
          <span className="badge text-bg-danger small">
            {alertMessages[attribute.id]}
          </span>
        )}
      </Form.Label>

      <div className="d-flex flex-wrap gap-2">
        {filteredOptions.map((option) => (
          <div key={option.id} className="checkbox-wrapper-47 m-0">
            <input
              type="checkbox"
              id={`attr-${attribute.id}-opt-${option.id}`}
              name={`attr-${attribute.id}-opt-${option.id}`}
              value={option.id}
              onChange={() =>
                handleOptionChange(option.id, option.price_modifier, attribute.id)
              }
              checked={selectedOptions.some(
                (opt) => opt.id === option.id && opt.attributeId === attribute.id
              )}
            />
            <label htmlFor={`attr-${attribute.id}-opt-${option.id}`}>
              {option.name}
              {/* price_modifier > 0 filtered out, so no need to show price here */}
            </label>
          </div>
        ))}
      </div>
    </Form.Group>
  );
})}
            </Form>
          </div>
        )}

        <Form.Group className="mb-4">
          <Form.Label className="fw-semibold">Special Instructions</Form.Label>
          <Form.Control
            type="text"
            placeholder="Add special instructions..."
            value={special_instructions}
            onChange={(e) => setSpecialInstructions(e.target.value)}
            className="border-secondary-subtle"
          />
        </Form.Group>
      </Modal.Body>

      <div className="px-4 py-3 border-top bg-white">
        <button
          className="btn w-100 fw-semibold py-3 rounded-3 text-white"
          onClick={handleAddItem}
          disabled={disabledAddToCart}
        >
          {isLoading ? 'Adding...' : 'Add to Cart (0.00)'}
        </button>
      </div>
    </div>
  </Modal>
);

};

export default AddRewardItemModal;  
